import React, { useEffect, useState } from "react"
import * as Yup from "yup"
import { useFormik } from "formik"
import { Col, Row, FormFeedback, Label, Form } from "reactstrap"
import Select from "react-select"
import { getSalesOfficeListForSelect, updateDealerSalesOfficeMapping } from "helpers/UAM/salesoffice.helper"
import CommonDialog from "components/Common/CommonDialog"
import ToastDialog from "common/ToastDialog"
import { getRegionList } from "http/Region"

const SalesOffice = ({ dealerData, getDealerInfo }) => {
  const [loading, setLoading] = useState(false)
  const [salesOfficeOptions, setSalesOfficeOptions] = useState([])
  const [dealerSalesOffice, setDealerSalesOffice] = useState([])
  const [regionOptions, setRegionOptions] = useState([])
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [toastInfo, setToastInfo] = useState({ showToast: false });


  useEffect(() => {
    if (dealerData?.region) {
      getSalesOfficeListForSelect({ region: dealerData?.region })
        .then(response => {
          if (response.status && response.code == 200) {
            let responseData = response.data.salesOfficeData
            let salesOfficeData = responseData.map(elem => {
              return { label: elem.salesOfficeName, value: elem.id }
            })
            setSalesOfficeOptions(salesOfficeData)
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
    if (dealerData?.salesOffice) {
      let previousData = {
        label: dealerData?.salesOffice[0].sales_office_name,
        value: dealerData?.salesOffice[0].id,
      }
      setDealerSalesOffice(previousData)
    }

  }, [dealerData?.region])

  useEffect(() => {
    getRegionLists()
  }, [])

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      salesOffice: dealerSalesOffice.value || '',
      region: dealerData?.region || ''
    },
    validationSchema: Yup.object({
      salesOffice: Yup.string().required("Please Select Sales Office"),
      region: Yup.string().required("Please Select Region"),
    }),
    onSubmit: values => {
      const message = 'Are you sure want to update SalesOffice Mapping?'
      setShowCommonDialog({ isShow: true, message: message })
    },
  })

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      updateSalesOffice()

    } else {

      setShowCommonDialog({ isShow: false })
    }
  }

  const updateSalesOffice = () => {
    setLoading(true);
    const { values } = validation
    let insertData = {
      dealerId: dealerData?.id,
      salesOffice: values.salesOffice,
      region: values.region
    }
    updateDealerSalesOfficeMapping(insertData)
      .then((response) => {
        if (response.status) {
          setLoading(false);
          getDealerInfo(dealerData?.id)
          setToastInfo({
            message: response.message,
            showToast: true,
            role: "success",
          });
        } else {
          setLoading(false);
          setToastInfo({
            message: response.message,
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
      })
  }

  const getRegionLists = async () => {
    const apiRes = await getRegionList();
    if (apiRes.status) {
      const regions = apiRes?.data?.data
      setRegionOptions(regions.map(item => {
        return { label: item['regionName'], value: item['regionName'] }
      }));
    } else {
      setToastInfo({ message: apiRes.message, showToast: true, role: "error" });
    }
  }

  const getSalesOfficeOptions = async region => {
    const response = await getSalesOfficeListForSelect({ region })
    validation.setFieldValue("salesOffice", '')
    if (response.status) {
      const { salesOfficeData } = response.data
      setSalesOfficeOptions(
        salesOfficeData.map(item => {
          return { label: item["salesOfficeName"], value: item["id"] }
        })
      )
    } else {
      setSalesOfficeOptions([])
      setToastInfo({
        message: response.message,
        showToast: true,
        role: "error",
      })
    }
  }

  return (
    <div>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <h4 className="card-title mb-2">Associated Sales Office</h4>
        <Row className="mb-4">
          <Col sm={6} className="mt-3">
            <Label
              htmlFor="horizontal-password-Input "
            >
              Region<span style={{color:'red'}}>*</span>
            </Label>
            <Select
              options={regionOptions}
              name="region"
              id="region"
              className={`select-dropdown ${validation.touched.region &&
                validation.errors.region &&
                "is-invalid"
                }`}
              classNamePrefix="select2-selection"
              value={regionOptions.find((option) => option.value == validation.values.region)}
              onChange={option => {
                validation.setFieldValue(
                  "region",
                  option.value
                )
                getSalesOfficeOptions(option.value)
              }}
            />
            {validation.touched.region && validation.errors.region ? (
              <FormFeedback type="invalid">{validation.errors.region}</FormFeedback>
            ) : null}
          </Col>
          <Col sm={6} className="mt-3">
            <Label
              htmlFor="horizontal-password-Input"
            >
              Sales Office<span style={{color:'red'}}>*</span>
            </Label>
            <Select
              options={salesOfficeOptions}
              name="salesOffice"
              id="salesOffice"
              className={`select-dropdown ${validation.touched.salesOffice &&
                validation.errors.salesOffice &&
                "is-invalid"
                }`}
              classNamePrefix="select2-selection"
              value={salesOfficeOptions.find((option) => option.value == validation.values.salesOffice)}
              onChange={option => {
                validation.setFieldValue(
                  "salesOffice",
                  option.value
                )
              }}
            />
            {validation.touched.salesOffice && validation.errors.salesOffice ? (
              <FormFeedback type="invalid">{validation.errors.salesOffice}</FormFeedback>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-end mb-2">
              <button type="submit" className="btn btn-success save-customer">
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm ms-2 me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                {loading && <span>Saving</span>}
                {!loading && <span>Save</span>}
              </button>
            </div>
          </Col>
        </Row>
      </Form>
      {
        showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </div >
  )
}

export default SalesOffice
